import React, { useState } from "react";
import {
  IGroupInfo,
  ImmutableChat,
  IUserInfo,
} from "@home-health-notify/domain";
import ButtonRevoke from "./ButtonRevoke";
import { RevokeReferralModal } from "./RevokeReferralModal";

type RevokeReferralType = {
  chat: ImmutableChat;
  userInfo: IUserInfo;
};

const RevokeReferral = ({ chat, userInfo }: RevokeReferralType) => {
  const [isConfirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const groupInfo = chat.chatInfo as IGroupInfo;

  const onCloseConfirmationDialog = () => {
    setConfirmationDialogOpen(false);
  };

  return (
    <>
      <ButtonRevoke onClick={() => setConfirmationDialogOpen(true)} />
      <RevokeReferralModal
        userInfo={userInfo}
        groupInfo={groupInfo}
        chat={chat}
        isOpen={isConfirmationDialogOpen}
        onClose={onCloseConfirmationDialog}
      />
    </>
  );
};

export default RevokeReferral;
